module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e08-61ac035a8465b5403306dedf8b44c22d.jpg";